import {
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalFooter,
  ModalBody,
  ModalCloseButton,
  useDisclosure,
  Button,
  FormControl,
  Input,
  FormLabel,
  Select,
  useToast,
} from "@chakra-ui/react";
import React, { useState } from "react";
import AssessmentDataService from "../../services/Assessment";
import { updateAssessmentData } from "../../Config/AsessmentData";

export const UpdateEhcExpertModal = ({
  isOpen,
  onClose,
  func,
  func1,
  selectedData,
  setSelectedData,
}: any) => {
  const token = localStorage.getItem("logged_in_user_token");
  const initialRef = React.useRef(null);
  const toast = useToast();

  const [selectedExpert, setSelectedExpert] = useState("");

  const experts = [
    { name: "User1", id: "expert4_tamannarajpal" },
    { name: "User2", id: "expert_mahi" },
    { name: "User3", id: "expert_user3" },
    { name: "User4", id: "expert_navyav" },
    { name: "Jigyasa", id: "expert_jigyasa" },
    { name: "Tania", id: "expert_tania" },
    { name: "Prakriti", id: "expert_prakriti" },
  ];

  const updateExpert = () => {
    selectedData.forEach((row: any) => {
      const updatedAssessment = {
        ...updateAssessmentData(row.data),
        expert: selectedExpert,
      };

      AssessmentDataService.update(updatedAssessment, row.id, token)
        .then((response: any) => {
          console.log(response.data, "response.data");
          setSelectedData([]);
          setSelectedExpert("");
          func1(false);
          func();
          onClose();
          toast({
            position: "top",
            title: "Expert Updated",
            status: "success",
            duration: 1500,
            isClosable: true,
          });
        })
        .catch((e: Error) => {
          console.log(e);
        });
    });
  };

  // console.log(selectedExpert, "selectedExpert");

  return (
    <>
      <Modal initialFocusRef={initialRef} isOpen={isOpen} onClose={onClose}>
        <ModalOverlay />
        <ModalContent>
          <ModalHeader>Update Expert</ModalHeader>
          <ModalCloseButton />
          <ModalBody pb={6}>
            <FormControl>
              <FormLabel>Select Expert</FormLabel>
              <Select
                placeholder="Select Expert"
                value={selectedExpert}
                onChange={(e) => {
                  setSelectedExpert(e.target.value);
                }}
              >
                {experts.map((el) => (
                  <option key={el.id} value={el.id}>
                    {el.name}
                  </option>
                ))}
              </Select>
            </FormControl>
          </ModalBody>

          <ModalFooter>
            <Button
              bgColor="#327171"
              color={"white"}
              mr={3}
              onClick={() => {
                updateExpert();
              }}
            >
              Submit
            </Button>
            <Button bgColor={"red"} color={"white"} onClick={onClose}>
              Cancel
            </Button>
          </ModalFooter>
        </ModalContent>
      </Modal>
    </>
  );
};
